"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountCampaignDiscountType = exports.DiscountCampaignStatus = exports.PopupFrequencyEnum = void 0;
var PopupFrequencyEnum;
(function (PopupFrequencyEnum) {
    PopupFrequencyEnum[PopupFrequencyEnum["Once"] = 1] = "Once";
    PopupFrequencyEnum[PopupFrequencyEnum["EachPageRefresh"] = 2] = "EachPageRefresh";
    PopupFrequencyEnum[PopupFrequencyEnum["EachPageView"] = 3] = "EachPageView";
    PopupFrequencyEnum[PopupFrequencyEnum["PerDay"] = 4] = "PerDay";
})(PopupFrequencyEnum || (exports.PopupFrequencyEnum = PopupFrequencyEnum = {}));
var DiscountCampaignStatus;
(function (DiscountCampaignStatus) {
    DiscountCampaignStatus[DiscountCampaignStatus["Inactive"] = 0] = "Inactive";
    DiscountCampaignStatus[DiscountCampaignStatus["Active"] = 1] = "Active";
})(DiscountCampaignStatus || (exports.DiscountCampaignStatus = DiscountCampaignStatus = {}));
var DiscountCampaignDiscountType;
(function (DiscountCampaignDiscountType) {
    DiscountCampaignDiscountType[DiscountCampaignDiscountType["SignUpDiscount"] = 1] = "SignUpDiscount";
    DiscountCampaignDiscountType[DiscountCampaignDiscountType["BirthdayDiscount"] = 2] = "BirthdayDiscount";
    DiscountCampaignDiscountType[DiscountCampaignDiscountType["HolidayDiscount"] = 4] = "HolidayDiscount";
    DiscountCampaignDiscountType[DiscountCampaignDiscountType["OrderAmountDiscount"] = 3] = "OrderAmountDiscount";
    DiscountCampaignDiscountType[DiscountCampaignDiscountType["OtherDiscount"] = 5] = "OtherDiscount";
})(DiscountCampaignDiscountType || (exports.DiscountCampaignDiscountType = DiscountCampaignDiscountType = {}));
